import React, { useState, useContext } from 'react';
import axios from 'axios';
import { AuthContext } from './AuthContext';

function LegacyMigrate() {
  const { user } = useContext(AuthContext); // Benutzer aus Context abrufen
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState('');

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      setMessage('Please select a file.');
      return;
    }

    if (!user || !user.id) {
      setMessage('You must be logged in to upload feedback.');
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    formData.append('userId', user.id); // Benutzer-ID hinzufügen

    try {
      const response = await axios.post('/api/legacy/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setMessage(response.data.message || 'File processed successfully!');
    } catch (error) {
      setMessage(error.response?.data?.error || 'An error occurred.');
    }
  };

  return (
    <div className="legacy-migrate">
      <h2>Upload Legacy Feedbacks</h2>
      <form onSubmit={handleUpload}>
        <input type="file" accept=".pdf" onChange={handleFileChange} />
        <button type="submit">Upload</button>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
}

export default LegacyMigrate;
